import React from 'react';
import CustomInputWithIcon from '../../../common/ui/CustomInputWithIcon';
import Select from 'react-select';

export const FieldsSelect = ({ name, title, onChange, options, value, placeholder }) => {
  const handleChange = (values) => {
    onChange(name, values.value);
  };

  const colourStyles = {
    control: (styles) => ({ ...styles, backgroundColor: '#fff' }),
    option: (styles, { isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        fontSize: '0.875rem',
        color: isDisabled ? null : isSelected ? 'white' : isFocused ? 'white' : null,
        backgroundColor: isDisabled
          ? null
          : isSelected
          ? '#1ba7ae'
          : isFocused
          ? '#1ba7ae9c'
          : null,

        ':active': {
          ...styles[':active'],
          backgroundColor: !isDisabled && (isSelected ? '#fff' : '#1ba7ae'),
        },
      };
    },
  };

  return (
    <CustomInputWithIcon icon="select" title={title}>
      <Select
        className="custom-select-container"
        classNamePrefix="custom-select"
        options={options}
        onChange={handleChange}
        value={options ? options.find((option) => option.value === value) : ''}
        styles={colourStyles}
        placeholder={placeholder}
      />
    </CustomInputWithIcon>
  );
};
